import React, { Component, Fragment } from 'react';
import { get, postWithHeaders, postWithHeadersResponse } from "../../../server/actions";
import { currency_symbol } from '../../../server/constants'
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip'
import '../../../../src/assets/css/react-table.css'
import DateRangePicker from 'react-bootstrap-daterangepicker';
import 'bootstrap-daterangepicker/daterangepicker.css';
import { BeatLoader } from 'react-spinners';
import '../../../../node_modules/react-datetime/css/react-datetime.css';
import NotificationSystem from 'react-notification-system';
import Modal from 'react-modal'
import PropTypes from "prop-types";
import Toggle from 'react-toggle';
import EmailSelect from '../../SchoolAdmin/ManagePayments/EmailSelect';
import {
    _addNotification, _addNotificationError,
    formatDate, allowNumericWithdecimal, getWeekStartEndDates, getMonthStartEndDates, getSessionStartEndDates,
    getTodayStartEndDates,
    showFile, convertTwoDecimalPoint, allowNumberWithDecimalNegative, getLastMonthStartEndDates
} from "../../../server/util";
import moment from 'moment';
//import { debugger } from 'fusioncharts';
var _ = require('lodash');
var converter = require('number-to-words');
const modalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '60%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};
const adjustPayModalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};
const adjustPaymentObjConst = {
    studentRecId: 0,
    studentName: '',
    balAmount: 0,
    adjustAmount: 0,
    reason: "",
    payType: ''
}
class StudentDeposits extends Component {
    constructor(props) {
        super(props)
        this.state = {
            mealSchoolId: 0,
            schoolId: 0,
            loading: false,
            transactionData: [],
            ID: 0,
            studentFName: '',
            studentLName: '',
            accountBalance: 0.00,
            hdataFilter: { ID: 0, tdate: 'D', sdate: new Date(), edate: new Date() },
            schoolYear: sessionStorage.getItem('schoolYearValue'),
            gradeIndex: 0,
            payModalIsOpen: false,
            refundModalIsOpen: false,
            transferModalIsOpen: false,
            isEqualDistSelected: false,
            isTransEqualDistSelected: false,
            emailList: [],
            primaryStudentData: {},
            showEmailSelect: false,
            payModalObject: {
                mealSchoolId: 0,
                transactionType: '',
                paymentType: '',
                transactionDescription: '',
                checkNumb: '',
                totalTransactionAmount: 0.00,
                studentWiseTransactions: [] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                                 
            },
            refundModalObject: {
                reasonForRefund: '',
                studentWiseRefundTransactions: []
            },
            payTransferModalObject: {
                mealSchoolId: 0,
                //transactionType:'',
                //paymentType:'',
                transactionDescription: '',
                //checkNumb:'',
                totalTransactionAmount: 0.00,
                studentWiseTransactions: [] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                                 
            },
            adjustPayment: {
                adjustPayModalIsOpen: false,
                isDebit: false,
                adjustPaymentObj: JSON.parse(JSON.stringify(adjustPaymentObjConst))
            }
        }
        this.getAccountHistoryData = this.getAccountHistoryData.bind(this);
        this.closePaymentModel = this.closePaymentModel.bind(this);
        this.closePaymentAdjustModel = this.closePaymentAdjustModel.bind(this);
        this.computAmount = this.computAmount.bind(this);
        this.equalDistribute = this.equalDistribute.bind(this);
        this.equalTransferDistribute = this.equalTransferDistribute.bind(this);
    }
    componentWillMount = () => {
        let id = this.props.data;
        const { schoolId } = this.state.schoolId;
        this.setState({ ID: id, mealSchoolId: schoolId }, () => {
            this.getAccountHistoryData(id);
        });
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    getAccountHistoryData = (id, isPdf = false) => {
        let _self = this;
        let userInfo = {};
        if ((sessionStorage.getItem('ROLE')) === "ROLE_ADMIN") {
            userInfo = JSON.parse(sessionStorage.getItem('loggedInUserInfo'));
        }
        let date = {}
        if (this.state.hdataFilter.tdate === 'W') {
            date = getWeekStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'M') {
            date = getMonthStartEndDates(new Date())
        }
        else if (this.state.hdataFilter.tdate === 'LM') {
            date = getLastMonthStartEndDates(new Date())
        } else if (this.state.hdataFilter.tdate === 'Y') {
            date = getSessionStartEndDates(sessionStorage.getItem('schoolYearValue'))
        } else if (this.state.hdataFilter.tdate === 'C') {
            date = { startDate: this.state.hdataFilter.sdate, endDate: this.state.hdataFilter.edate }
        } else {
            date = getTodayStartEndDates(new Date())
        }
        this.setState({ loading: true });
        get('/reports/transactionsHistory?studentRecId=' + id + '&startDate=' + moment(date.startDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&endDate=' + moment(date.endDate).utc().format("YYYY-MM-DDTHH:mm:ss") + '&fileExport=' + isPdf + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                if (isPdf) {
                    return res.blob();
                } else {
                    return res.json();
                }
            }
        }).then(data => {
            if (isPdf) {
                let filename = (this.state.studentFName + ' ' + this.state.studentLName) + '_AccountHistory.pdf';
                showFile(data, filename);
                this.setState({ loading: false });
            } else {
                console.log(JSON.stringify(data.studentAccountDetails.accountTransactionHistories));
                this.setState({
                    transactionData: (data.studentAccountDetails || {}).accountTransactionHistories || [], loading: false,
                    studentFName: data.studentAccountDetails.studentFName, studentLName: data.studentAccountDetails.studentLName,
                    accountBalance: data.studentAccountDetails.accBal
                })
            }
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );
    }
    filterDaySessionGrades = () => {

        let _filterData = [];
        _filterData = this.state.transactionData.filter(item => {
            if (item.transactionType === "Deposit") {
                return (item)
            }
        });
        return _filterData
    }
    addPayment = (action, row) => {
        let payObj = this.state.payModalObject;
        payObj.mealSchoolId = sessionStorage.getItem('SchoolId');
        payObj.transactionType = 'Deposit';
        payObj.paymentType = 'Cash';
        payObj.transactionDescription = '';
        payObj.checkNumb = '';
        payObj.totalTransactionAmount = 0.00;
        if (action === 'single') {
            payObj.studentWiseTransactions = [
                {
                    studentRecId: this.state.ID,
                    name: this.state.studentFName + ' ' + this.state.studentLName,
                    balAmt: this.state.accountBalance,
                    transactionAmount: 0.00
                }
            ] //{ "studentRecId":375,"name":"","balAmt":0.00,"transactionAmount":200},                 
        }
        this.setState({ payModalIsOpen: true, payModalObject: payObj });
    }
    moneyTransfer = (action, row) => {
        let payTransferObj = this.state.payTransferModalObject;
        let username = this.props.parentDetails.userName
        payTransferObj.studentWiseTransactions = []
        payTransferObj.mealSchoolId = sessionStorage.getItem('SchoolId');
        payTransferObj.totalTransactionAmount = 0.00;
        get('/studentUsers/search/findByEmailAndYearAndSchool?username=' + username + '&schoolYear=' + sessionStorage.getItem('schoolYearValue') + '&mealSchoolId=' + sessionStorage.getItem('SchoolId') + '&access_token=').then((response) => {
            this.setState({ loading: true })
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then((data) => {
            this.setState({ loading: false })
            let studentsList = data._embedded.studentUsers || {};
            //let student_List = [];            
            console.log(JSON.stringify(studentsList, null, 2))
            studentsList.forEach(student => {
                if (student.studentId != this.props.studentId) {
                    //student_List.push(student);
                    payTransferObj.studentWiseTransactions.push(
                        {
                            studentRecId: student._links.self.href.split("/").pop(),
                            name: student.firstName + ' ' + student.lastName,
                            balAmt: student.accBalance,
                            transactionAmount: 0.00
                        }
                    )
                }
            });
            if (payTransferObj.studentWiseTransactions) {
                this.setState({ transferModalIsOpen: true, primaryStudentData: row, payTransferModalObject: payTransferObj });
            } else {
                this.setState({ alertModalIsOpen: true, primaryStudentData: {} });
            }

        }).catch(
            (error) => {
                this.setState({ loading: false })
                console.log('Parent dashboard error', error);
            }
        )
    }
    closePaymentAdjustModel = () => {
        let _adjustPayment = this.state.adjustPayment;
        _adjustPayment.adjustPayModalIsOpen = false;
        _adjustPayment.adjustPaymentObj = JSON.parse(JSON.stringify(adjustPaymentObjConst))
        this.setState({ adjustPayment: _adjustPayment })
    }
    closePaymentModel = () => {
        let payObj = this.state.payModalObject;
        payObj = {};
        payObj.studentWiseTransactions = []
        this.setState({ payModalIsOpen: false, payModalObject: payObj, isEqualDistSelected: false, showEmailSelect: false, emailList: [] });
        //this.getDataByGrade(typeof this.state.currentGrade === "number" && this.state.currentGrade != 0 ? converter.toWords(this.state.currentGrade) : this.state.currentGrade,this.state.action,this.state.schoolYear );
    }
    closePaymentTrnaferModel = () => {
        //this.setState({transferModalIsOpen:false});
        let payObj = this.state.payTransferModalObject;
        payObj = {};
        payObj.studentWiseTransactions = []
        this.setState({ transferModalIsOpen: false, payTransferModalObject: payObj, isTransEqualDistSelected: false });
        //this.getDataByGrade(typeof this.state.currentGrade === "number" && this.state.currentGrade != 0 ? converter.toWords(this.state.currentGrade) : this.state.currentGrade,this.state.action,this.state.schoolYear);
    }
    equalDistribute = (amount) => {
        let payObj = this.state.payModalObject;
        if (amount != 0) {
            let distAmt = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            let balAmt = amount - (distAmt * payObj.studentWiseTransactions.length);
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            })
            payObj.studentWiseTransactions[payObj.studentWiseTransactions.length - 1].transactionAmount = (distAmt + balAmt).toFixed(2);
        }
        else {
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = 0
            })
        }
        this.setState({ payModalObject: payObj })
    }
    equalTransferDistribute = (amount) => {
        let payObj = this.state.payTransferModalObject;
        if (amount != 0) {
            let distAmt = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            let balAmt = amount - (distAmt * payObj.studentWiseTransactions.length);
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = parseFloat((amount / payObj.studentWiseTransactions.length).toFixed(2))
            })
            payObj.studentWiseTransactions[payObj.studentWiseTransactions.length - 1].transactionAmount = (distAmt + balAmt).toFixed(2);
        }
        else {
            payObj.studentWiseTransactions.map((stud) => {
                stud.transactionAmount = 0
            })
        }
        this.setState({ payTransferModalObject: payObj })
    }
    computAmount() {
        let payObj = this.state.payModalObject;
        let _computeAmount = 0.0;
        payObj.studentWiseTransactions.map((s) => {
            _computeAmount = _computeAmount + parseFloat(s.transactionAmount)
        });
        return parseFloat(_computeAmount.toFixed(2));
    }
    computTransferAmount() {
        let payObj = this.state.payTransferModalObject;
        let _computeAmount = 0.0;
        payObj.studentWiseTransactions.map((s) => {
            _computeAmount = _computeAmount + parseFloat(s.transactionAmount)
        });
        return parseFloat(_computeAmount.toFixed(2));
    }
    paymentSubmit = (e, callback) => {
        e.preventDefault();
        let payObj = Object.assign({}, this.state.payModalObject);
        let _studentWiseTransactions = []
        payObj.studentWiseTransactions.map(stud => {
            if ((stud.transactionAmount || 0) != 0) {
                _studentWiseTransactions.push(stud);
            }
        })
        payObj.studentWiseTransactions = _studentWiseTransactions;
        if ((payObj.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transation amount.", this);
            callback(true);
            return false;
        }
        if (payObj.totalTransactionAmount != this.computAmount()) {
            _addNotificationError("Total transaction amount & sum of individual students amount not matched.", this);
            callback(true);
            return false;
        }
        if (payObj.paymentType === "Check") {
            if (payObj.checkNumb === '') {
                _addNotificationError("Please provide check no.", this);
                return false;
            }
        }
        if (payObj.paymentType === "CreditCard") {
            if (payObj.checkNumb === '') {
                _addNotificationError("Please provide transaction number.", this);
                return false;
            }
        }
        let emailList = []
        this.state.emailList.forEach(email => {
            if (email.selected) {
                emailList.push(email.email)
            }
        });
        payObj.parentUserEmails = emailList.join(',');
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeaders("/transactions/depositAmtThruOffline?studentRecId="+payObj.studentWiseTransactions[0].studentRecId+"&mealSchoolId="+sessionStorage.getItem('SchoolId')+"&access_token=", JSON.stringify(payObj),headers).then((response) => {
            if (response.status === 200) {
                this.setState({ loading: false })

                this.closePaymentModel();
                _addNotification('Lunch Balance added successfully.', this);
                this.getAccountHistoryData(this.state.ID);
                callback(true);
            } else if (!response.ok) {
                throw Error(response.statusText);
            }
            //alert(response.status)
        }).catch(
            (error) => {
                _addNotificationError('Failed to add payment ! Try again.', this);
                console.log('Send Notification Error', error);
                this.closePaymentModel();
            }
        );
    }
    paymentTransferSubmit = (e) => {
        e.preventDefault();
        let payObj = Object.assign({}, this.state.payTransferModalObject);
        let _studentWiseTransactions = []
        this.state.payTransferModalObject.studentWiseTransactions.map(obj => {
            if (parseFloat(((obj.transactionAmount || '') == '') ? 0 : obj.transactionAmount) > 0.00) {
                _studentWiseTransactions.push(obj);
            }
        })
        payObj.studentWiseTransactions = _studentWiseTransactions;
        if ((payObj.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transaction amount.", this);
            return false;
        }
        let payTransferObj = {
            sourceTransferTransaction: {
                mealSchoolId: sessionStorage.getItem('SchoolId'),
                transactionDescription: "Amount transfer to the sibling",
                totalTransactionAmount: this.state.accountBalance,
                studentWiseTransactions: [
                    {
                        studentRecId: this.state.ID,
                        transactionAmount: payObj.totalTransactionAmount
                    }
                ]
            },
            tragetTransferTransaction: payObj
        }
        let headers = {
            'Content-Type': 'application/json'
        };
        postWithHeadersResponse("/transactions/transferBalance?access_token=", JSON.stringify(payTransferObj), headers).then((response) => {
            if (response.statusCode === 200) {
                this.setState({ loading: false })
                _addNotification(response.statusMessage, this);
                this.closePaymentTrnaferModel();
                this.getAccountHistoryData(this.state.ID);

            } else if (!response.ok) {
                throw Error(response.errorMessage);
            }
            //alert(response.status)
        }).catch(
            (error) => {
                _addNotificationError(error.message, this);
                console.log('Send Notification Error', error);
                this.closePaymentTrnaferModel();
            }
        );
    }
    closeEmailSelect = () => {
        this.setState({ showEmailSelect: false, emailList: [] })
    }
    openEmailSelect = (e) => {
        let _payObj = Object.assign({}, this.state.payModalObject);
        let _studentWiseTransactions = []
        _payObj.studentWiseTransactions.map(stud => {
            if ((stud.transactionAmount || 0) != 0) {
                _studentWiseTransactions.push(stud);
            }
        })
        _payObj.studentWiseTransactions = _studentWiseTransactions;
        if ((_payObj.totalTransactionAmount || 0) == 0.00) {
            _addNotificationError("Please provide transaction amount.", this);
            return false;
        }
        if (_payObj.totalTransactionAmount != this.computAmount()) {
            _addNotificationError("Total transaction amount & sum of individual students amount not matched.", this);
            return false;
        }
        if (_payObj.paymentType === "Check") {
            if (_payObj.checkNumb === '') {
                _addNotificationError("Please provide check no.", this);
                return false;
            }
        }
        if (_payObj.paymentType === "CreditCard") {
            if (_payObj.checkNumb === '') {
                _addNotificationError("Please provide transaction number.", this);
                return false;
            }
        }
        /* let _emailIds=[];
        _payObj.studentWiseTransactions.forEach(stu=>{
           let idx=this.state.students.findIndex(item=>{
               return item._links.self.href.split("/").pop()==stu.studentRecId
           })
           if(idx>=0){
            _emailIds.push(this.state.students[idx].parentuser.userName);
            if((this.state.students[idx].parentuser.parentAltEmail||'').trim().length>0){
                _emailIds.push(this.state.students[idx].parentuser.parentAltEmail);
            }
           }
        });
        const uniqueSet = new Set(_emailIds);
        const uniqueEmails = ([...uniqueSet]).map(id=>{
            return {email:id,selected:false}
        })
        if(uniqueEmails.length==1){
            uniqueEmails[0].selected=true
            this.setState({emailList:uniqueEmails},
                this.paymentSubmit(e)) 
        }else{
            if(uniqueEmails.length>1){
                this.setState({showEmailSelect:true,emailList:uniqueEmails})
            }
        } */
        this.paymentSubmit(e);
    }
    render() {
        const checkboxProps = {
            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (
            <section className="full-width clearfix">
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading'
                    style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="container ">
                    <div className="sectionTitle">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="col-md-6">
                                    <h2 id="deleteLabel">{'Deposits:  ' + this.state.studentFName + ' ' + this.state.studentLName}
                                        {/* <span>Account History</span> */}
                                    </h2></div>
                                <div className="col-md-6 pull-right button-group-section">
                                    <button
                                        className="btn bg-color-4 button-xs pull-right"
                                        title="Adjust Payment (Debit/Credit)" onClick={() => {
                                            let _adjustPayment = this.state.adjustPayment;
                                            _adjustPayment.adjustPayModalIsOpen = true;
                                            let _adjustPaymentObj = _adjustPayment.adjustPaymentObj;
                                            _adjustPaymentObj.studentRecId = this.state.ID;
                                            _adjustPaymentObj.studentName = this.state.studentFName + ' ' + this.state.studentLName;
                                            _adjustPaymentObj.balAmount = this.state.accountBalance;
                                            //_adjustPaymentObj.payType="AdjustmentDR";
                                            _adjustPayment.adjustPaymentObj = _adjustPaymentObj;
                                            this.setState({ adjustPayment: _adjustPayment })
                                        }}
                                        style={{
                                            float: 'right',
                                            margin: '5px'
                                        }}>
                                        <i className="fa tbl-rounded-icon">+/-</i> Adjust Payment
                                    </button>
                                    <button
                                        className="btn bg-color-2 button-xs pull-right"
                                        title="Transfer" onClick={() => this.moneyTransfer('single')}
                                        style={{
                                            float: 'right',
                                            margin: '5px'
                                        }}>
                                        <i className="fa fa-exchange"></i> Transfer
                                    </button>
                                    <button
                                        className="btn btn-warning button-xs pull-right"
                                        onClick={() => this.addPayment('single')}
                                        style={{
                                            float: 'right',
                                            margin: '5px'
                                        }}>
                                        <i className="fa fa-money"></i> Add Payment
                                    </button>
                                </div>
                            </div></div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-info" style={{ padding: '5px', marginBottom: '5px' }} >
                                <div onChange={(event) => {
                                    let hdataFilter = this.state.hdataFilter;
                                    hdataFilter.tdate = event.target.value;
                                    this.setState({ hdataFilter: hdataFilter })
                                    if (event.target.value !== "C") {
                                        this.getAccountHistoryData(this.state.ID, false);
                                    }
                                }}>
                                    <label class="rbcontainer">Today
                                        <input type="radio" name="hdrange" value="D" defaultChecked={this.state.hdataFilter.tdate === 'D'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Week
                                        <input type="radio" name="hdrange" value="W" defaultChecked={this.state.hdataFilter.tdate === 'W'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Month
                                        <input type="radio" name="hdrange" value="M" defaultChecked={this.state.hdataFilter.tdate === 'M'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">Last Month
                                        <input type="radio" name="hdrange" value="LM" defaultChecked={this.state.hdataFilter.tdate === 'LM'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">This Year
                                        <input type="radio" name="hdrange" value="Y" defaultChecked={this.state.hdataFilter.tdate === 'Y'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    <label class="rbcontainer">Custom Dates
                                        <input type="radio" name="hdrange" value="C" defaultChecked={this.state.hdataFilter.tdate === 'C'} />
                                        <span className="rbcheckmark"></span>
                                    </label>
                                    {
                                        this.state.hdataFilter.tdate === 'C' ?
                                            <DateRangePicker onApply={(event, picker) => {
                                                let hdataFilter = this.state.hdataFilter;
                                                hdataFilter.sdate = picker.startDate._d;
                                                hdataFilter.edate = picker.endDate._d;
                                                this.setState({ hdataFilter: hdataFilter })
                                                console.log('sdate --:', event, picker)
                                                this.getAccountHistoryData(this.state.ID, false);
                                            }}>
                                                <button className="btn btn-xs bg-color-1" style={{ margin: '0px', minWidth: '20px' }}><i className="fa fa-calendar"></i></button>
                                            </DateRangePicker> : null
                                    }
                                    <a title="Click to Download PDF"
                                        onClick={() => { this.getAccountHistoryData(this.state.ID, true) }//this.quickReports('Pdf','currentDay')
                                        } target='_blank'
                                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF pull-right"><i /></a>
                                </div></div></div></div>
                    <div>
                        <ReactTable
                            data={this.filterDaySessionGrades()}
                            columns={[
                                {
                                    Header: "Date",
                                    accessor: "transactionDateTime",
                                    style: { textAlign: 'center' },
                                    width: 300
                                },
                                {
                                    Header: "Transaction",
                                    id: 'transaction',
                                    style: { textAlign: 'center' },
                                    width: 200,
                                    accessor: row => {
                                        return (<span>{
                                            row.transactionType === 'Deposit' || row.transactionType === "InstantPayment" ?
                                                row.transactionType + ' - ' + (row.paymentType === 'CreditCard' ? 'CC' : row.paymentType) :
                                                (row.purchaseItemType === 'TransferDR' ? 'Transfer Withdrawal' :
                                                    row.purchaseItemType === '' ? row.paymentType : row.purchaseItemType)}
                                        </span>)
                                    }
                                },
                                {
                                    Header: `Account (${currency_symbol(this.state.mealSchoolId)})`,
                                    id: 'amount',
                                    style: { textAlign: "center" },
                                    width: 200,
                                    accessor: row => {
                                        return (
                                            <div>
                                                {
                                                    currency_symbol(this.state.mealSchoolId) + ' '
                                                    + (row.transactionType === 'Deposit' || ((row.transactionType === 'ImportBalance' || row.transactionType === 'Adjustment' || row.transactionType === 'Refund') && row.paymentType) ? '+' : '-') + convertTwoDecimalPoint(row.transactionAmount)
                                                }
                                            </div>
                                        );
                                    }
                                },
                                /*  {
                                     Header: `Balance (${currency_symbol(this.state.mealSchoolId)})`,
                                     id: "finalBalance",
                                     accessor: row => {
                                         return (
                                             <div style={{ textAlign: "right" }}>
                                                 {currency_symbol(this.state.mealSchoolId) + ' ' + convertTwoDecimalPoint(row.finalBalance)}
                                             </div>
                                         );
                                     }
                                 }, */
                                {
                                    Header: "Note",
                                    id: "note",
                                    style: { textAlign: 'center' },
                                    width: 300,
                                    minWidth: 75,
                                    filterable: false,
                                    Cell: row => {
                                        return (
                                            <Fragment>
                                                <a data-tip data-for={'ah-' + row.index}>{row.original.note}</a>
                                                <ReactTooltip id={'ah-' + row.index} aria-haspopup='true' type="dark" effect="float">
                                                    <div>
                                                        {row.original.note}
                                                    </div>
                                                </ReactTooltip>
                                            </Fragment>
                                        )
                                    }
                                }
                            ]} defaultPageSize={10} {...checkboxProps} /></div>
                    <Modal isOpen={this.state.payModalIsOpen} style={modalStyles} >
                        <NotificationSystem ref="notificationSystem" />
                        <div className="modal-header row">
                            <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Add Payments</h4>
                            <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.closePaymentModel()}>X</button></div>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12">
                                    <form name="frmPay" className="">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12">
                                                <div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                    <label htmlFor="payType">Payment Type</label>
                                                    <select className="form-control" name="payType" value={this.state.payModalObject.paymentType} onChange={
                                                        (e) => {
                                                            let payObj = this.state.payModalObject;
                                                            payObj.paymentType = e.target.value;
                                                            this.setState({ payModalObject: payObj })
                                                        }
                                                    } >
                                                        <option value='Cash'>Cash</option>
                                                        <option value='Check'>Check</option>
                                                        <option value='CreditCard'>Credit card</option>
                                                    </select>
                                                </div>
                                                {(this.state.payModalObject.paymentType != 'Cash') ?
                                                    (<div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                        <label htmlFor="checkNumb">{this.state.payModalObject.paymentType === 'Check' ? 'Check No' : 'Transaction No '}</label>
                                                        <input type="text" className="form-control" name="checkNumb" value={this.state.payModalObject.checkNumb}
                                                            onChange={(e) => {
                                                                let payObj = this.state.payModalObject;
                                                                payObj.checkNumb = e.target.value;
                                                                this.setState({ payModalObject: payObj })
                                                            }} />
                                                    </div>

                                                    ) : null}
                                                <div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                    <label htmlFor="amount">Amount</label>
                                                    <div className="input-group">
                                                        <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                        <input type="text" className="form-control" onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                            name="amount" value={this.state.payModalObject.totalTransactionAmount}
                                                            placeholder="Amount" onChange={(e) => {
                                                                let payObj = this.state.payModalObject;
                                                                payObj.totalTransactionAmount = e.target.value;
                                                                if (payObj.studentWiseTransactions.length === 1) {
                                                                    payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                                }
                                                                else {
                                                                    if (this.state.isEqualDistSelected) {
                                                                        this.equalDistribute(convertTwoDecimalPoint(payObj.totalTransactionAmount));
                                                                    }
                                                                }
                                                                this.setState({ payModalObject: payObj });
                                                            }} />
                                                    </div>
                                                </div>
                                                {this.state.payModalObject.studentWiseTransactions.length > 1 ?
                                                    <div className="form-group col-xs-3 col-sm-3 col-md-3">
                                                        <label>Equally distribute</label>
                                                        <div> <button type="button" className="btn-social btn-facebook btn-square" style={{ width: '34px', height: '34px' }} onClick={(e) => {
                                                            let payObj = this.state.payModalObject;
                                                            if (e.currentTarget.classList.contains('btn-facebook-filled')) {
                                                                e.currentTarget.childNodes[0].className = "fa fa-square-o";
                                                                this.setState({ isEqualDistSelected: false })
                                                            } else {
                                                                e.currentTarget.childNodes[0].className = "fa fa-check-square-o";
                                                                let amount = payObj.totalTransactionAmount;
                                                                this.equalDistribute(amount);
                                                                this.setState({ isEqualDistSelected: true })
                                                            }
                                                            e.currentTarget.classList.toggle('btn-facebook-filled');
                                                        }} >
                                                            <i className="fa fa-square-o" ></i>
                                                        </button></div>
                                                    </div> : null
                                                }
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12">
                                                <table className="table table-payment-modal">
                                                    <thead>
                                                        <tr>
                                                            <td>Name</td>
                                                            <td>Available Bal</td>
                                                            <td>Amount</td>
                                                        </tr>
                                                    </thead>
                                                    <tbody style={{ maxHeight: '300px', overflowY: 'auto', display: 'block' }}>
                                                        {
                                                            this.state.payModalObject.studentWiseTransactions.map((row, key) => {
                                                                return (<tr>
                                                                    <td>{row.name}</td>
                                                                    <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.balAmt)}</td>
                                                                    <td>
                                                                        <div className="input-group">
                                                                            <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                                            <input type="text"
                                                                                disabled={this.state.payModalObject.studentWiseTransactions.length === 1 || this.state.isEqualDistSelected === true}
                                                                                className="form-control" data-id={key} name="amount" value={row.transactionAmount} onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                                onChange={(e) => {
                                                                                    let payModel = this.state.payModalObject;
                                                                                    payModel.studentWiseTransactions[e.target.getAttribute('data-id')].transactionAmount = (e.target.value === '' ? 0.00 : e.target.value);
                                                                                    payModel.totalTransactionAmount = parseFloat((_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount)))).toFixed(2))
                                                                                    this.setState({ payModalObject: payModel });
                                                                                }}
                                                                                placeholder="Amount" />
                                                                        </div></td>
                                                                </tr>)
                                                            })
                                                        }
                                                    </tbody>
                                                    <tfoot><tr>
                                                        <td></td>
                                                        <td>Total Amount :</td>
                                                        <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(this.computAmount())}</td></tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            <button type="button" className="btn btn-danger btn-xs"
                                                onClick={() => this.closePaymentModel()}>
                                                <i className="fa fa-times-circle"
                                                    style={{ margin: '0 0 0 5px' }}></i> Cancel
                                            </button>
                                            <button type="button" id="paySubmit" onClick={(e) => {
                                                this.openEmailSelect(e)
                                            }}
                                                className="btn btn-success btn-xs">
                                                <i className="fa fa-check-circle"
                                                    style={{ margin: '0 0 0 5px' }}></i> Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={this.state.transferModalIsOpen} style={modalStyles} >
                        <NotificationSystem ref="notificationSystem" />
                        <div className="modal-header row">
                            <h4 className="modal-title modal-title-color col-md-6" id="deleteLabel">Payment Transfer</h4>
                            <div className="col-md-6"><button type="button" className="pull-right btn-danger" onClick={() => this.closePaymentTrnaferModel()}>X</button></div>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-xs-12 col-sm-12 col-md-12">
                                    <form name="frmPay" className="">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-12">
                                                <h5 className="color-6 h5-transfer-border">Transfer Source Account Details:</h5>
                                                <table className="table table-payment-modal" style={{ marginBottom: '0px' }}>
                                                    <thead><tr>
                                                        <td>Name</td>
                                                        <td>Available Bal</td>
                                                        <td>Amount</td></tr>
                                                    </thead>
                                                    <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                        <tr>
                                                            <td>{this.state.studentFName} {this.state.studentLName}</td>
                                                            <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(this.state.accountBalance)}</td>
                                                            <td>
                                                                <div className="input-group">
                                                                    <span className="input-group-addon">{currency_symbol()}</span>
                                                                    <input type="text"
                                                                        disabled=""
                                                                        className="form-control" name="amount" value={this.state.payTransferModalObject.totalTransactionAmount}
                                                                        onKeyPress={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                        onKeyUp={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                        onBlur={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                        placeholder="Amount" onChange={(e) => {
                                                                            let payObj = this.state.payTransferModalObject;

                                                                            if (e.target.value > this.state.accountBalance) {
                                                                                _addNotificationError("Insufficient amount.", this);
                                                                                return false;
                                                                            }
                                                                            payObj.totalTransactionAmount = e.target.value;
                                                                            if (payObj.studentWiseTransactions.length === 1) {
                                                                                payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                                            }
                                                                            else {
                                                                                if (this.state.isTransEqualDistSelected) {
                                                                                    this.equalTransferDistribute(convertTwoDecimalPoint(payObj.totalTransactionAmount));
                                                                                }
                                                                            }
                                                                            this.setState({ payTransferModalObject: payObj })
                                                                        }} />
                                                                </div></td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <h5 className="color-6 h5-transfer-border">Transfer Target Account Details:</h5>

                                                <div className="row">
                                                    <div className="col-xs-12 col-sm-12 col-md-12">
                                                        {
                                                            this.state.payTransferModalObject.studentWiseTransactions.length > 1 ?
                                                                <div className="col-xs-4" style={{ padding: '0px' }}>
                                                                    <label style={{ margin: '0px 20px 0px 4px' }}>Equally distribute</label>
                                                                    <span><button type="button" className="btn-social btn-facebook btn-square" style={{ width: '34px', height: '34px' }} onClick={(e) => {
                                                                        let payObj = this.state.payTransferModalObject;
                                                                        if (e.currentTarget.classList.contains('btn-facebook-filled')) {
                                                                            e.currentTarget.childNodes[0].className = "fa fa-square-o";
                                                                            this.setState({ isTransEqualDistSelected: false })
                                                                        } else {
                                                                            e.currentTarget.childNodes[0].className = "fa fa-check-square-o";
                                                                            let amount = payObj.totalTransactionAmount;
                                                                            this.equalTransferDistribute(amount);
                                                                            this.setState({ isTransEqualDistSelected: true })
                                                                        }
                                                                        e.currentTarget.classList.toggle('btn-facebook-filled');
                                                                    }} >
                                                                        <i className="fa fa-square-o" ></i>
                                                                    </button></span>
                                                                </div> : null
                                                        }
                                                        <div className="col-xs-4" style={{ padding: '0px' }}>
                                                            <div className="input-group">
                                                                <span className="input-group-addon">{currency_symbol()}</span>
                                                                <input type="text" className="form-control"
                                                                    onKeyPress={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                    onKeyUp={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                    onBlur={(e) => { allowNumberWithDecimalNegative(e) }}
                                                                    name="amount" value={this.state.payTransferModalObject.totalTransactionAmount}
                                                                    placeholder="Amount" onChange={(e) => {
                                                                        let payObj = this.state.payTransferModalObject;

                                                                        if (e.target.value > this.state.accountBalance) {
                                                                            _addNotificationError("Insufficient amount.", this);
                                                                            return false;
                                                                        }
                                                                        payObj.totalTransactionAmount = e.target.value;
                                                                        if (payObj.studentWiseTransactions.length === 1) {
                                                                            payObj.studentWiseTransactions[0].transactionAmount = payObj.totalTransactionAmount
                                                                        }
                                                                        else {
                                                                            if (this.state.isTransEqualDistSelected) {
                                                                                this.equalTransferDistribute(parseFloat(payObj.totalTransactionAmount));
                                                                            }
                                                                        }
                                                                        this.setState({ payTransferModalObject: payObj })
                                                                    }} />
                                                            </div>
                                                        </div>

                                                        <table className="table table-payment-modal">
                                                            <thead><tr>
                                                                <td>Name</td>
                                                                <td>Available Bal</td>
                                                                <td>Amount</td></tr>
                                                            </thead>
                                                            <tbody style={{ maxHeight: '200px', overflowY: 'auto', display: 'block' }}>
                                                                {
                                                                    this.state.payTransferModalObject.studentWiseTransactions.map((row, key) => {
                                                                        return (<tr>
                                                                            <td>{row.name}</td>
                                                                            <td>{currency_symbol() + ' ' + convertTwoDecimalPoint(row.balAmt)}</td>
                                                                            <td>
                                                                                <div className="input-group">
                                                                                    <span className="input-group-addon" id="basic-addon1">{currency_symbol()}</span>
                                                                                    <input type="text"
                                                                                        disabled={this.state.payTransferModalObject.studentWiseTransactions.length === 1 || this.state.isTransEqualDistSelected === true}
                                                                                        className="form-control" data-id={key} name="amount" value={row.transactionAmount} onKeyPress={(e) => { allowNumericWithdecimal(e) }} onKeyUp={(e) => { allowNumericWithdecimal(e) }} onBlur={(e) => { allowNumericWithdecimal(e) }}
                                                                                        onChange={(e) => {
                                                                                            let payModel = this.state.payTransferModalObject;
                                                                                            if (e.target.value > this.state.accountBalance) {
                                                                                                _addNotificationError("Insufficient amount.", this);
                                                                                                return false;
                                                                                            }
                                                                                            payModel.studentWiseTransactions[e.target.getAttribute('data-id')].transactionAmount = (e.target.value === '' ? 0.00 : e.target.value);
                                                                                            payModel.totalTransactionAmount = parseFloat((_.sum(_.map(payModel.studentWiseTransactions, d => parseFloat(d.transactionAmount)))).toFixed(2))
                                                                                            this.setState({ payModalObject: payModel });
                                                                                        }}
                                                                                        placeholder="Amount" />
                                                                                </div></td>
                                                                        </tr>)
                                                                    })
                                                                }
                                                            </tbody>
                                                            <tfoot><tr>
                                                                <td></td>
                                                                <td>Total Amount :</td>
                                                                <td>{currency_symbol() + ' ' + this.computTransferAmount()}</td></tr>
                                                            </tfoot>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="text-right">
                                            <button type="button" className="btn btn-danger btn-xs"
                                                onClick={() => this.closePaymentTrnaferModel()}>
                                                <i className="fa fa-times-circle"
                                                    style={{ margin: '0 0 0 5px' }}></i> Cancel
                                            </button>
                                            <button type="button" id="" onClick={this.paymentTransferSubmit}
                                                className="btn btn-success btn-xs">
                                                <i className="fa fa-check-circle"
                                                    style={{ margin: '0 0 0 5px' }}></i> Submit
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </Modal>
                    <Modal isOpen={this.state.adjustPayment.adjustPayModalIsOpen} style={adjustPayModalStyles}>
                        <div className="modal-header row">
                        <NotificationSystem ref="notificationSystem" />
                            <h4 className="modal-title modal-title-color col-md-10" id="deleteLabel">Adjust Payment</h4>
                            <div className="col-md-2"><button type="button" className="pull-right btn-danger" onClick={() => {
                                this.closePaymentAdjustModel();
                            }}>X</button></div>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12 col-sm-12">
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12">
                                            <h4 className="color-3">{this.state.adjustPayment.adjustPaymentObj.studentName}</h4>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-6">
                                            <label>Balance Amount:</label>
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                            <span>{currency_symbol() + ' ' + this.state.adjustPayment.adjustPaymentObj.balAmount}</span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-6 col-sm-6">
                                            <label>Adjustment Type:</label>
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                            <div>
                                                <label className='custom-label' style={{ lineHeight: '15px', paddingBottom: '7px', verticalAlign: 'middle', paddingRight: '10px', color: (this.state.adjustPayment.isDebit) ? 'rgb(234, 112, 102)' : '#757576' }}>Debit</label>
                                                <Toggle
                                                    checked={(!this.state.adjustPayment.isDebit) ? false : this.state.adjustPayment.isDebit}
                                                    icons={{
                                                        checked: <i className='fa fa-check' style={{ fontSize: '13px' }} />,
                                                        unchecked: <i className='fa fa-check' style={{ fontSize: '13px' }} />,
                                                    }}
                                                    className='custom-Toggle-color'
                                                    onChange={(e) => {
                                                        let _adjustPayment = this.state.adjustPayment
                                                        _adjustPayment.isDebit = e.target.checked
                                                        this.setState({ adjustPayment: _adjustPayment });
                                                    }} />
                                                <label className='custom-label' style={{ lineHeight: '15px', paddingBottom: '7px', verticalAlign: 'middle', paddingLeft: '10px', color: (!this.state.adjustPayment.isDebit) ? '#5cb85c' : '#757576' }}>Credit</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-6 col-sm-6">
                                            <label style={{ paddingTop: '6px' }}>Adjust Amount* : </label>
                                        </div>
                                        <div className="col-md-6 col-sm-6">
                                            <input type="text" className="form-control"
                                                value={this.state.adjustPayment.adjustPaymentObj.adjustAmount}
                                                onKeyUp={(e) => { allowNumericWithdecimal(e) }}
                                                onChange={(e) => {
                                                    let _adjustPayment = this.state.adjustPayment;
                                                    _adjustPayment.adjustPaymentObj.adjustAmount = (e.target.value)
                                                    this.setState({ adjustPayment: _adjustPayment })
                                                }} required/>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-112 col-sm-12">
                                            <label>Adjustment Note* :</label>
                                            <textarea className="form-control" rows={5}
                                                value={this.state.adjustPayment.adjustPaymentObj.reason} onChange={(e) => {
                                                    let _adjustPayment = this.state.adjustPayment;
                                                    _adjustPayment.adjustPaymentObj.reason = (e.target.value)
                                                    this.setState({ adjustPayment: _adjustPayment })
                                                }} ></textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="text-right" style={{ paddingTop: '15px' }}>
                                        <button type="button" className="btn btn-danger btn-xs"
                                            style={{ margin: '0 0 0 5px' }} onClick={() => {
                                                this.closePaymentAdjustModel();
                                            }}
                                        ><i className="fa fa-times-circle"></i> Cancel
                                        </button>
                                        <button type="button" className="btn btn-success btn-xs"
                                            style={{ margin: '0 0 0 5px' }}
                                            onClick={() => {
                                                let _self = this
                                                let transObject = {
                                                    "mealSchoolId": 0,
                                                    "transactionType": "Adjustment",
                                                    "purchaseItemType": "AdjustmentDR",
                                                    "paymentType": "AdjustmentCR",
                                                    "transactionDescription": "",
                                                    "checkNumb": "",
                                                    "totalTransactionAmount": 0,
                                                    "studentWiseTransactions": [
                                                        {
                                                            "studentRecId": 0,
                                                            "name": "",
                                                            "transactionAmount": 0
                                                        }
                                                    ]
                                                };
                                                let amount = this.state.adjustPayment.adjustPaymentObj.adjustAmount || ''
                                                if ((amount === '' ? 0 : parseFloat(amount)) === 0) {
                                                    _addNotificationError("Please provide adjustment amount.", this);
                                                    return false;
                                                }
                                                if (this.state.adjustPayment.adjustPaymentObj.reason.trim() === '') {
                                                    _addNotificationError("Please provide reason for adjustment payments.", this);
                                                    return false;
                                                }
                                                transObject.mealSchoolId = sessionStorage.getItem('SchoolId')
                                                transObject.transactionDescription = this.state.adjustPayment.adjustPaymentObj.reason;
                                                transObject.totalTransactionAmount = this.state.adjustPayment.adjustPaymentObj.adjustAmount || 0;
                                                if (this.state.adjustPayment.isDebit == true) {
                                                    this.state.adjustPayment.adjustPaymentObj.purchaseItemType = 'AdjustmentDR'
                                                    transObject.totalTransactionAmount = this.state.adjustPayment.adjustPaymentObj.adjustAmount || 0;
                                                    transObject.paymentType = undefined
                                                } else {
                                                    this.state.adjustPayment.adjustPaymentObj.payType = 'AdjustmentCR'
                                                    transObject.purchaseItemType = undefined
                                                }
                                                transObject.studentWiseTransactions[0].transactionAmount = transObject.totalTransactionAmount;
                                                transObject.studentWiseTransactions[0].name = this.state.adjustPayment.adjustPaymentObj.studentName;
                                                transObject.studentWiseTransactions[0].studentRecId = this.state.adjustPayment.adjustPaymentObj.studentRecId;
                                                let headers = {
                                                    'Content-Type': 'application/json'
                                                };
                                                _self.setState({ loading: true })
                                                postWithHeaders('/transactions/adjustBalance?access_token=', JSON.stringify(transObject), headers)
                                                    .then(
                                                        (response) => {
                                                            if (!response.ok) {
                                                                throw Error(response.statusText);
                                                            }
                                                            return response.json();
                                                        }).then((response) => {
                                                            if (response.statusCode === 200) {
                                                                _self.setState({ loading: false })
                                                                _addNotification(response.statusMessage, _self);
                                                                //_self.getDataByGrade(typeof _self.state.currentGrade === "number" && _self.state.currentGrade != 0 ? converter.toWords(_self.state.currentGrade) : _self.state.currentGrade,_self.state.action,_self.state.schoolYear );
                                                                _self.closePaymentAdjustModel();
                                                                this.getAccountHistoryData(this.state.ID);
                                                            } else if (!response.ok) {
                                                                throw Error(response.statusText);
                                                            }
                                                        }).catch(
                                                            (error) => {
                                                                _self.setState({ loading: false })
                                                                _addNotificationError(error.message, _self);
                                                                console.log('Send Notification Error', error.message);
                                                            });
                                            }}
                                        ><i className="fa fa-check-circle"></i> Submit
                                        </button>
                                    </div>
                                </div></div>
                        </div>

                    </Modal>
                </div>
            </section>
        )
    }
}
StudentDeposits.contextTypes = {
    router: PropTypes.object.isRequired
}
export default StudentDeposits;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/SetUpSchool/studentDeposits.jsx